import { useState } from 'react';
import { useAppSelector } from 'src/hooks/redux';
import { getCalculatedSuggestion } from 'src/redux/shopping_cart/api';

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const NOT_FOUND_ERROR = 'No encontramos ningún cliente con ese correo electrónico';
const NETWORK_ERROR = 'Ocurrió un error al buscar el cliente, inténtalo de nuevo';

const validate = (value: string): string => {
    if (!value.trim()) return 'El campo es requerido';
    if (!EMAIL_REGEX.test(value)) {
        return 'Ingresa un correo electrónico válido';
    }
    return '';
};

export const useRetentionSearch = () => {
    const token = useAppSelector((state) => state.User?.token ?? '');
    const [query, setQueryState] = useState('');
    const [submittedQuery, setSubmittedQuery] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const setQuery = (value: string) => {
        setQueryState(value);
        if (error) setError('');
    };

    const submit = async () => {
        const validationError = validate(query);
        if (validationError) {
            setError(validationError);
            return;
        }
        setLoading(true);
        try {
            const response = await getCalculatedSuggestion(
                { country: 'MX', email: query, type_user: 2 },
                token
            );
            if (!response.success) {
                setError(response.message || NOT_FOUND_ERROR);
                return;
            }
            setSubmittedQuery(query);
        } catch {
            setError(NETWORK_ERROR);
        } finally {
            setLoading(false);
        }
    };

    const clearSearch = () => {
        setQueryState('');
        setSubmittedQuery('');
        setError('');
    };

    return { query, submittedQuery, error, loading, setQuery, submit, clearSearch };
};
